import api from '../utils/api';

export const sellerStorefrontService = {
  getPublicStorefront: async (slug, params = {}) => {
    const response = await api.get(`/public/seller/${slug}`, { params });
    return response.data.data || response.data;
  },

  getMyStorefront: async () => {
    const response = await api.get('/seller/storefront/me');
    return response.data.data || response.data;
  },

  updateDeliveryRadius: async ({ radiusKm, panIndia }) => {
    const response = await api.patch('/seller/storefront/delivery-radius', { radiusKm, panIndia });
    return response.data;
  },

  getDeliveryRadiusOptions: async () => {
    const response = await api.get('/seller/storefront/delivery-radius-options');
    return response.data.data || response.data;
  },

  submitSellerRating: async (orderId, { rating, comment }) => {
    const response = await api.post(`/orders/${orderId}/seller-rating`, { rating, comment });
    return response.data;
  },
};
